import { FC } from 'react';
import { InssMarginIndicators as Indicators } from '../../../models/InssMargin/InssMarginModels';

const SOON = 'Disponível em breve';

// Quantidade em destaque e o valor pequeno logo abaixo; sem número, o card mostra só
// "Disponível em breve".
const Kpi: FC<{ title: string; quantity?: number; amount?: string; highlight?: boolean }> = ({ title, quantity, amount, highlight }) => (
    <div className={`inss-margin-kpi${highlight ? ' inss-margin-kpi--highlight' : ''}`}>
        <span className="inss-margin-kpi__title">{title}</span>
        {quantity === undefined ? (
            <b className="inss-margin-kpi__value inss-margin-kpi__value--soon">{SOON}</b>
        ) : (
            <>
                <b className="inss-margin-kpi__value">{quantity.toLocaleString('pt-BR')}</b>
                <span className="inss-margin-kpi__amount">{amount ?? `Valor: ${SOON.toLowerCase()}`}</span>
            </>
        )}
    </div>
);

// Cards fixos acima das abas (FE2.1). Nesta entrega (E1) só a quantidade da carteira tem
// número; o resto chega com a simulação e a digitação (E2).
const InssMarginIndicators: FC<{ indicators: Indicators }> = ({ indicators }) => (
    <div className="inss-margin-kpis" aria-label="Indicadores da carteira">
        <Kpi title="Oportunidades" quantity={indicators.portfolio} />
        <Kpi title="Simuladas" />
        <Kpi title="Propostas digitadas" highlight />
    </div>
);

export default InssMarginIndicators;
